export const DEFAULT_CARDS_PER_PAGE = 15
